export default __webpack_public_path__ + "static/media/Flex_Care.7dbcbecb.png";